import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import {
  subscribeToTaskSource,
  subscribeToJiraStatus,
} from '../../services/jira';
import ProdaffTasksTab from './components/ProdaffTasksTab.component';
import JiraTasksTab from './components/JiraTasksTab.component';
import styles from './Tasks.module.scss';

const ManageTasks = () => {
  const { activeCompany } = useSelector((state) => state.auth.profile);
  const companyId = activeCompany?.companyId;

  const [taskSource, setTaskSource] = useState('prodaff');
  const [jiraStatus, setJiraStatus] = useState({
    connected: false,
    siteUrl: null,
    lastImportAt: null,
    selectedProjects: [],
  });

  useEffect(() => {
    if (!companyId) return;
    const unsubscribe = subscribeToTaskSource(companyId, setTaskSource);
    return () => unsubscribe();
  }, [companyId]);

  useEffect(() => {
    if (!companyId || taskSource !== 'jira') return;
    const unsubscribe = subscribeToJiraStatus(companyId, setJiraStatus);
    return () => unsubscribe();
  }, [companyId, taskSource]);

  return (
    <div className={styles.tasksPage}>
      {taskSource === 'jira' ? (
        <JiraTasksTab companyId={companyId} jiraStatus={jiraStatus} />
      ) : (
        <ProdaffTasksTab />
      )}
    </div>
  );
};

export default ManageTasks;
